import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Note } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = Note;

export const ListNoteVideoLessonsSlice = createSlice({
  name: "ListNoteVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    ListNoteVideoLesson: (state, action) => {
      state.isLoading = true;
    },

    successListNoteVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListNoteVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  ListNoteVideoLesson,
  successListNoteVideoLessons,
  failureListNoteVideoLessons,
} = ListNoteVideoLessonsSlice.actions;

export default ListNoteVideoLessonsSlice.reducer;
